export const User = {
  userId: 1,
};

export const userReviewCount = 9;
